// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

import React from 'react';
import { useHistory } from 'react-router-dom';
import { logout } from '../utils/adminAuth';
import '../assets/css/admin-dashboard.css';

const AdminDashboardLayout = ({ children }) => {
    const history = useHistory();

    const handleLogout = () => {
        logout();
        history.push('/adm-gsconnect/login');
    };

    return (
        <div className="admin-dashboard-layout">
            <header className="admin-dashboard-header">
                <div className="header-content">
                    <div className="logo-section">
                        <h2 className="logo-text">gsConnect Admin</h2>
                    </div>
                    <div className="header-actions">
                        <button 
                            className="btn-logout" 
                            onClick={handleLogout}
                        >
                            <i className="fas fa-sign-out-alt"></i> Sair
                        </button>
                    </div>
                </div>
            </header>
            <main className="admin-dashboard-main">
                <div className="dashboard-container">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default AdminDashboardLayout;

